import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react'; // this is not optional!
import log from './logging';
import { Provider, useSelector } from 'react-redux';
import { HeadProvider } from 'react-head';
import { PersistGate } from 'redux-persist/lib/integration/react';
// CSS stuff (ATTENTION: ORDER MATTERS IN PRODUCTION MODE!!!)
import 'libjs/semantic-ui-css/semantic.css';
import './styles/main.global.css';
import { View, BootLoader } from './templating/view';
import { setDocumentLang } from './i18n/utils';
log.startup('creating App and initializing ...');
const DocumentLanguage = ()=>{
    let language = useSelector((root)=>root.meta.language);
    useEffect(()=>setDocumentLang(language), [
        language
    ]);
    return null;
};
//XXX: use a ErrorBoundary toplevel here?
const BrowserApp = ({ store, persistor })=>/*#__PURE__*/ _jsx(PersistGate, {
        persistor: persistor,
        loading: /*#__PURE__*/ _jsx(BootLoader, {}),
        children: /*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: /*#__PURE__*/ _jsxs(HeadProvider, {
                children: [
                    /*#__PURE__*/ _jsx(DocumentLanguage, {}),
                    /*#__PURE__*/ _jsx(View, {})
                ]
            })
        })
    });
const ExpressApp = (store, headTags = [])=>/*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsxs(HeadProvider, {
            headTags: headTags,
            children: [
                /*#__PURE__*/ _jsx(DocumentLanguage, {}),
                /*#__PURE__*/ _jsx(View, {})
            ]
        })
    });
export { BrowserApp, ExpressApp };
